import { isNotUndefined } from "@faire/typescript";
import { ILocaleKey } from "@faire/web-api--source/indigofair/locale/ILocaleKey";
import { convertLocaleToCountryLocaleString } from "@faire/web/common/localization/languageWithCountryOptions";

export function getRobotLocalePrefixFromPathname(
  pathname: string,
  availableLanguageSelectorLocales: Array<ILocaleKey>
): string | undefined {
  const splitPathName = pathname.split("/");
  if (splitPathName.length >= 2) {
    return getRobotLocalePrefixFromLocale(
      splitPathName[1],
      availableLanguageSelectorLocales
    );
  } else {
    return undefined;
  }
}

export function getRobotLocalePrefixFromLocale(
  locale: string | undefined,
  availableLanguageSelectorLocales: Array<ILocaleKey>
): string | undefined {
  const allowedRoboLocales = getAllowedRobotLocales(
    availableLanguageSelectorLocales
  );
  if (allowedRoboLocales && locale && allowedRoboLocales.includes(locale)) {
    return `/${locale}`;
  }
  return undefined;
}

export function getRobotUrlWithLocale(
  availableLanguageSelectorLocales: Array<ILocaleKey>,
  canonicalUrl: string | undefined
): string {
  let urlWithLocale = "https://www.faire.com";
  if (canonicalUrl) {
    const canonicalPathname = canonicalUrl.replace("https://www.faire.com", "");
    const robotLocale = getRobotLocalePrefixFromPathname(
      canonicalPathname,
      availableLanguageSelectorLocales
    );
    if (robotLocale) {
      urlWithLocale = urlWithLocale + robotLocale;
    }
  }
  return urlWithLocale + "/";
}

function getAllowedRobotLocales(
  availableLanguageSelectorLocales: Array<ILocaleKey>
): Array<string> {
  const allowedRobotLocales = availableLanguageSelectorLocales
    .map((localeKey) => convertLocaleToCountryLocaleString(localeKey))
    .filter(isNotUndefined);

  return allowedRobotLocales;
}
